import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { ButtonType } from 'office-ui-fabric-react/lib/Button';
import { lightable, lighted } from 'owa-lightning';
import strings from 'owa-strings/owa-options-strings';
var AddStorageAccountCallout = /** @class */ (function (_super) {
    tslib_1.__extends(AddStorageAccountCallout, _super);
    function AddStorageAccountCallout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function () {
            lighted(_this.props.lid);
        };
        return _this;
    }
    AddStorageAccountCallout.prototype.render = function () {
        var gotItButtonProps = {
            buttonType: ButtonType.primary,
            children: strings.options_callout_addStorageAccount_button,
            onClick: this.onClose,
        };
        return (React.createElement(TeachingBubble, { calloutProps: {
                beakWidth: 15,
                directionalHint: 12 /* rightCenter */,
                minPagePadding: 50,
                gapSpace: 20,
            }, targetElement: this.props.target(), hasCloseIcon: true, onDismiss: this.onClose, hasSmallHeadline: true, headline: strings.options_callout_addStorageAccount_title, primaryButtonProps: gotItButtonProps }, strings.options_callout_addStorageAccount_body));
    };
    AddStorageAccountCallout = tslib_1.__decorate([
        observer,
        lightable
    ], AddStorageAccountCallout);
    return AddStorageAccountCallout;
}(React.Component));
export { AddStorageAccountCallout };
//# sourceMappingURL=AddStorageAccountCallout.js.map